const ArrowDownTask = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9504 5.98218H14.4555C17.561 5.98218 18.8371 8.18703 17.2796 10.8798L16.0223 13.0471L14.7651 15.2144C13.2076 17.9071 10.665 17.9071 9.10755 15.2144L7.85031 13.0471L6.59308 10.8798C5.06376 8.18703 6.33037 5.98218 9.44531 5.98218H11.9504Z"
      fill="#212326"
    />
  </svg>
);

export default ArrowDownTask;
